import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AcceptRoleInvitation = lazy(() => import("@/pages/AcceptRoleInvitation"));

export const Route = createFileRoute("/accept-role/$token")({
  component: AcceptRoleRoute,
});

function AcceptRoleRoute() {
  return (
    <Suspense fallback={null}>
      <AcceptRoleInvitation />
    </Suspense>
  );
}
